import { a as MODELOS_CHAVE, c as decomporChave, d as digitoModulo11, f as somaPonderada, i as raizDoCnpj, l as extrairChaves, n as formatarCnpj, o as calcularDigitoChave, r as normalizarCnpj, s as chaveValida, t as cnpjValido, u as normalizarChave } from "./cnpj-CT6DIYvC.mjs";
//#region src/identificadores/cpf.ts
const PESOS_DV1 = [
	10,
	9,
	8,
	7,
	6,
	5,
	4,
	3,
	2
];
const PESOS_DV2 = [11, ...PESOS_DV1];
function normalizarCpf(valor) {
	return valor.replace(/\D/g, "");
}
function cpfValido(valor) {
	const cpf = normalizarCpf(valor);
	if (!/^\d{11}$/.test(cpf) || /^(\d)\1{10}$/.test(cpf)) return false;
	const base = cpf.slice(0, 9);
	const dv1 = digitoModulo11(somaPonderada(base, PESOS_DV1));
	const dv2 = digitoModulo11(somaPonderada(`${base}${dv1}`, PESOS_DV2));
	return cpf.endsWith(`${dv1}${dv2}`);
}
//#endregion
export { MODELOS_CHAVE, calcularDigitoChave, chaveValida, cnpjValido, cpfValido, decomporChave, extrairChaves, formatarCnpj, normalizarChave, normalizarCnpj, normalizarCpf, raizDoCnpj };

//# sourceMappingURL=identificadores.mjs.map